import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import css from './FieldHelp.module.css';

const FieldHelp = props => {
  const { children, className, summary } = props;

  return (
    <details className={classNames(css.details, className)}>
      <summary className={css.summary}>
        {summary || <FormattedMessage id="FieldHelp.learnMore" />}
      </summary>
      <div className={css.content}>{children}</div>
    </details>
  );
};

FieldHelp.defaultProps = {
  className: null,
  summary: null,
};

FieldHelp.propTypes = {
  children: node.isRequired,
  className: string,
  summary: node,
};

export default FieldHelp;
